import React from 'react';
import PropTypes from 'prop-types';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';

const AdvancePISection = ({
  inputData,
  setInputData,
  className = '',
}) => {
  return (
    <div className={`row align-items-center g-3 ${className}`}>
      <div className="col-12 col-md-3">
        <div>{localization.capex_pi_placeholder}</div>
        <div style={{ fontSize: "10px"}}>{localization.capex_pi_placeholer2}</div>
      </div>

      <div className="col-auto">
        <div className="form-check">
          <input 
            className="form-check-input radio-custom" 
            type="radio" 
            name="advance_pi" 
            id="yes" 
            value="yes"
            checked={inputData['advance_pi'] === 'yes' ? true : false}
            onChange={(e) => {
              setInputData({
                ...inputData,
                advance_pi: 'yes'
              });
            }} />
          <label className="form-check-label" htmlFor="yes">
            Yes
          </label>
        </div>
      </div>

      <div className="col-12 col-md-3" id="contract-section">
        <ConstantInput
          label={localization.capex_pi_amount_placeholder}
          type="number"
          value={inputData?.advance_pi_amount}
          handleChange={(val) => {
            setInputData({
              ...inputData,
              advance_pi_amount: val
            });
          }}
          disabled={inputData['advance_pi'] === 'no' ? true : false}
        />
      </div>

      <div className="col-12 col-md-3" id="nomenclature-section">
        <ConstantInput
          label={localization.nomeneclatureHardware}
          type="text"
          handleChange={(val) => {
            setInputData({
              ...inputData,
              advance_pi_desc: val
            });
          }}
          value={inputData?.advance_pi_desc}
          disabled={inputData['advance_pi'] === 'no' ? true : false}
        />
      </div>

      <div className="col-auto">
        <div className="form-check">
          <input 
            className="form-check-input radio-custom" 
            type="radio" 
            name="advance_pi" 
            id="no" 
            value="no"
            checked={inputData['advance_pi'] === 'no' ? true : false}
            onChange={(e) => {
              setInputData({
                ...inputData,
                advance_pi: 'no'
              });
            }} />
          <label className="form-check-label" htmlFor="no">
            No
          </label>
        </div>
      </div>
    </div>
  );
};

AdvancePISection.propTypes = {
  inputData: PropTypes.object.isRequired,
  setInputData: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default AdvancePISection;
